const SCREENS = {
  BACKOFFICE_RANGE: 'PARAMETROALCADA',
  EDI_MANAGEMENT: 'GESTAO_EDI',
  EXTRA_VOLUME: 'VOLUMEEXTRA',
  FAIR_SHARE: 'FAIR_SHARE',
  FRANCHISES_BATCH: '113_PRCS_ORDE_VEND',
  HOME: 'HOME',
  INTERNATIONAL_EDI: '160_PRCS_EDI',
  INTERNATIONAL_SAMPLE: 'AMOSTRA_INTERNACIONAL',
  MANAGE: 'GERENCIAMENTO',
  NATIONAL_SAMPLE: 'AMOSTRA_NACIONAL',
  ND_MANAGE: 'GERENCIAMENTOND',
  ORDER: 'PEDIDO',
  OV: '100_ORDE_VEND',
  RANKING: 'RANKING',
  RECOMMENDATION: 'RECOMENDACAO_PEDIDOS',
  SALES_CALENDAR: 'SALES_CALENDAR', // TODO: UPDATE PERMISSION AFTER TRANSACTION CREATION ON BACKEND
  TECHNICAL_CONSULTATION: 'CONSULTA_TECNICA',
} as const

const ACTIONS_SCREENS = {
  APPROVE: 'APROVAR',
  CANCEL: 'CANCELAR',
  DELETE: 'EXCLUIR',
  DISMISS: 'REPROVAR',
  DOWNLOAD: 'DOWNLOAD',
  DUPLICATE: 'DUPLICAR',
  EDIT: 'EDITAR',
  GIVE_BACK: 'DEVOLVER',
  LIST: 'LISTA_HIER',
  NULL: null,
  PROCESS: 'PROCESSAR',
  REPROCESS: 'REPROCESSAR',
  REQUEST: 'SOLICITAR',
  RETURN: 'SOLI_RETN',
  SAVE: 'SALVAR',
  SEND: 'ENVIAR',
  SUMMARY: 'RESUMO',
} as const

export { ACTIONS_SCREENS, SCREENS }
